import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Icon } from '@lomarengas/design-system';
import {
  DataTable,
  DataTableItem,
  PaginationComponent,
  SearchBar,
  SectionHeader,
} from '../../common/components';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  selectSkiResortItemsLoadingStatus,
  selectSkiResortItems,
  selectSkiResortItemsPagination,
  SkiResortsFilter,
  getSkiResortsAsync,
} from './skiResortsSlice';
import { LOADING_STATUS } from '../../common/constants';
import {
  InitialPaginationParameters,
  InitialPaginationResponse,
} from '../../common/types/pagination.types';

function SkiResorts() {
  const dispatch = useAppDispatch();
  const skiResortItems = useAppSelector(selectSkiResortItems);
  const skiResortItemsPagination = useAppSelector(
    selectSkiResortItemsPagination,
  );
  const skiResortItemsLoadingStatus = useAppSelector(
    selectSkiResortItemsLoadingStatus,
  );

  const initialSkiResortsFilter: SkiResortsFilter = {
    PageNumber: InitialPaginationParameters.PageNumber,
    PageSize: InitialPaginationParameters.PageSize,
    searchString: '',
  };

  const [skiResortsFilter, setSkiResortsFilter] = useState(
    initialSkiResortsFilter,
  );
  const [skiResortsTableItems, setSkiResortsTableItems] = useState<
    DataTableItem[]
  >([]);

  const handleInputChange = event => {
    const { target } = event;
    const { value, name } = target;
    setSkiResortsFilter({ ...skiResortsFilter, [name]: value });
  };

  const doSearch = () => {
    skiResortsFilter.PageNumber = InitialPaginationParameters.PageNumber;
    dispatch(getSkiResortsAsync(skiResortsFilter));
  };

  const HandlePaginationClick = (Page: number) => {
    const paginatedFiltering = skiResortsFilter;
    paginatedFiltering.PageNumber = Page;
    setSkiResortsFilter(paginatedFiltering);
    dispatch(getSkiResortsAsync(paginatedFiltering));
  };

  useEffect(() => {
    doSearch();
  }, []);

  useEffect(() => {
    if (skiResortItems && skiResortItems.length > 0) {
      const formattedSkiResortsList: DataTableItem[] = [];
      skiResortItems?.forEach(item => {
        formattedSkiResortsList.push({
          ItemId: item.id,
          Items: [item.id, item.name],
          Url: `/locations/skiresorts/${item.id}`,
        });
      });
      setSkiResortsTableItems(formattedSkiResortsList);
    }
  }, [skiResortItems]);

  const AddNewButton: JSX.Element = (
    <Link to="/locations/skiresorts/addnew" className="btn btn-blue ps-16">
      <Icon CssClass="me-8" AriaLabel="Uusi" Name="plus" />
      Lisää uusi
    </Link>
  );

  return (
    <>
      <Helmet>
        <title>Sijaintitiedot - Hiihtokeskukset - Haku</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          Breadcrumbs={['Sijaintitiedot']}
          Children={AddNewButton}
          Title="Hiihtokeskukset"
        />

        <SearchBar
          FreeTextOnChangeHandler={handleInputChange}
          FreeTextPlaceholder="Hae..."
          SearchHandler={doSearch}
          IsLoading={skiResortItemsLoadingStatus !== LOADING_STATUS.IDLE}
          Value={skiResortsFilter.searchString}
        />

        {skiResortItemsLoadingStatus === LOADING_STATUS.IDLE &&
          skiResortItems !== null &&
          skiResortItems.length > 0 && (
            <>
              <DataTable
                ColumnWidths={[400, null]}
                Header={['Hiihtokeskuksen ID', 'Hiihtokeskuksen nimi']}
                Items={skiResortsTableItems}
                LegendText="hiihtokeskusta"
                TotalItems={skiResortItemsPagination.totalCount}
              />
              <PaginationComponent
                OnPageClick={HandlePaginationClick}
                PaginationData={skiResortItemsPagination}
              />
            </>
          )}

        {skiResortItemsLoadingStatus === LOADING_STATUS.IDLE &&
          skiResortItems !== null &&
          skiResortItems.length < 1 && (
            <p>Ei hiihtokeskuksia annetuilla hakuehdoilla.</p>
          )}
      </Container>
    </>
  );
}

export default SkiResorts;
